


class BirdViewMainNavigation {
    
    static bird_view_screen = [
        {
            name: 'Record',
            url: '/bird-view-record',
            variant: 'outlined',
            color: 'primary',
            textColor: '#000',
            borderColor: '#000',
            hoverBackgroundColor: '#000',
            hoverTextColor: '#fff',
        },
        {
            name: 'Control',
            url: '/bird-view-controls',
            variant: 'contained',
            backgroundColor: '#000',
            textColor: '#fff',
            hoverBackgroundColor: '#333',
            hoverTextColor: '#fff',
        }
    ];
    static bird_control_screen = [
        {
            name: 'View',
            url: '/bird-view',
            variant: 'contained',
            backgroundColor: '#000',
            textColor: '#fff',
            hoverBackgroundColor: '#333',
            hoverTextColor: '#fff',
        },
        {
            name: 'Record',
            url: '/bird-view-record',
            variant: 'outlined',
            color: 'primary',
            textColor: '#000',
            borderColor: '#000',
            hoverBackgroundColor: '#000',
            hoverTextColor: '#fff',
        }
    ];

}


export default BirdViewMainNavigation